module.exports = __webpack_public_path__ + "static/media/icon-material.png";